import React, { useContext, useEffect } from 'react';
import { buriedPoint, typeIdObj } from '@/pages/home/utils/buriedPoint';
import { StudioContext } from '../context';
import { CommonDashboardReport } from '@home/components/CommonDashboardReport';
import StudioState from '../components/StudioState';

const Datalab = () => {
  const { currentGame, currentMenu, menuPermission } = useContext(StudioContext);

  useEffect(()=> {
    if(!currentMenu){
      return;
    }

    const { id = '', name_en: dashboardName } = currentMenu || {};
    const { game_code: gameCode } = currentGame || {};
  
    const logObj = {
      pageId: '101001', 
      menuId: id,
      pageName: dashboardName,
      extInfo: '自定义报表—Studio承接页',
      pagePath: `/datalab/report/${dashboardName || ''}`,
      uid: gameCode || '',
      typeId: typeIdObj?.studio,
      gameName: currentGame?.game_name,
    };
    buriedPoint(logObj);

  },[currentGame, currentMenu]);

  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }

  return (
    <div className='dbh-studio-datalab-page-container'>
      {
        currentMenu?.dashboard_custom_id ? <CommonDashboardReport system={typeIdObj?.studio} dashboardId={currentMenu?.dashboard_custom_id} gameCode={currentGame?.game_code || ''} reportInfo={{
          gameCode: currentGame?.game_code,
          gameName: currentGame?.game_name,
          uid: currentGame?.game_code || '',
          typeId: typeIdObj?.studio,
          reportPageId: '101001',
          dashboardId: currentMenu?.dashboard_custom_id,
          pageName: currentMenu.name_en,
          dashboardName: currentMenu.name_en,
        }}/> : <StudioState/>
      }
    </div>
  );
};

export default Datalab;